<template>
<div :class='[{ "active": isActive }, { "active-error": isActive && !isStatusSuccess, "active-success": isActive && isStatusSuccess }]'
     class='b-bottom-hint'
     @click.stop>
    <div class='h-flex h-flex-space-between h-align-items-center h-width-100p'>
        <div class='h-mr-10'>
            {{ text }}
        </div>
        <FwIcon
            class='h-pointer'
            icon='close'
            size='15'
            color='#fff'
            @click.stop='close'>
        </FwIcon>
    </div>
</div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-facing-decorator';
import { EventBus } from '@/utils/EventBus';

const SERVER_ERROR = 'ERRORS.SERVER.ISSUE'; // TODO need solution

@Component({
    name: 'NotificationBar',
})
export default class NotificationBar extends Vue {
    isActive: boolean = false;
    isStatusSuccess: boolean = false;
    text: string | null = null;
    timeOut: number = 5000;
    timeOutObj: number | null = null;

    showNotification(text: string, status: boolean = false): void {
        if (this.timeOutObj) {
            clearTimeout(this.timeOutObj);
        }
        this.text = text || this.$i18n.t(SERVER_ERROR);
        this.isActive = true;
        this.isStatusSuccess = status;
        // @ts-ignore
        this.timeOutObj = setTimeout(() => {
            this.isActive = false;
        }, this.timeOut);
    }

    close(): void {
        this.isActive = false;
    }

    mounted(): void {
        EventBus.$on('sent-notification', this.showNotification);
    }

    beforeUnmount(): void {
        EventBus.$off('sent-notification', this.showNotification);
    }
}
</script>

<style lang='sass'>
.b-bottom-hint
    position: fixed
    margin: 0 auto
    top: -100px
    left: 0
    right: 0
    max-width: 350px
    min-height: 45px
    color: #fff
    display: flex
    align-items: center
    justify-content: center
    padding: 10px 15px
    transition: transform 0.3s, opacity 0.3s
    transform: translate(0, 100%)
    opacity: 0
    text-align: center
    z-index: 0
    border-radius: 4px
    font-size: 12px
    font-weight: 500

    &.active
        transform: translate(0, 0)
        opacity: 1
        z-index: 300
        top: 40px

        &-error
            background-color: rgb(239,17,60)

        &-success
            background-color: rgb(39,219,189)

</style>
